import React from 'react'
import useStyles from './styled'

const WarpImgLink = props => {
  const classes = useStyles()
  const { imageObject } = props
  return (
    <div>
      {imageObject.redirect ? (
        <a href={imageObject.redirect}>
          <img src={imageObject.url} className={classes.img} />
        </a>
      ) : (
        <img src={imageObject.url} className={classes.img} />
      )}
    </div>
  )
}
export default WarpImgLink
